var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotsBulk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0002 2C20.2094 2 22.0002 3.79086 22.0002 6L22.0002 12L2.00024 12L2.00024 6C2.00024 3.79086 3.79111 2 6.00024 2L18.0002 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22C3.79086 22 2 20.2091 2 18L2 12L22 12L22 18C22 20.2091 20.2091 22 18 22L6 22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0002 5.25C18.4145 5.25 18.7502 5.58579 18.7502 6L18.7502 8C18.7502 8.41421 18.4145 8.75 18.0002 8.75C17.586 8.75 17.2502 8.41421 17.2502 8L17.2502 6C17.2502 5.58579 17.586 5.25 18.0002 5.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 5.25C14.4145 5.25 14.7502 5.58579 14.7502 6L14.7502 8C14.7502 8.41421 14.4145 8.75 14.0002 8.75C13.586 8.75 13.2502 8.41421 13.2502 8L13.2502 6C13.2502 5.58579 13.586 5.25 14.0002 5.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0002 15.25C18.4145 15.25 18.7502 15.5858 18.7502 16L18.7502 18C18.7502 18.4142 18.4145 18.75 18.0002 18.75C17.586 18.75 17.2502 18.4142 17.2502 18L17.2502 16C17.2502 15.5858 17.586 15.25 18.0002 15.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 15.25C14.4145 15.25 14.7502 15.5858 14.7502 16L14.7502 18C14.7502 18.4142 14.4145 18.75 14.0002 18.75C13.586 18.75 13.2502 18.4142 13.2502 18L13.2502 16C13.2502 15.5858 13.586 15.25 14.0002 15.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotsBulk);
export default __webpack_public_path__ + "static/media/robotsBulk.9019e5408d9d1ab5616c5cb3589027ec.svg";
export { ForwardRef as ReactComponent };